import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-referral-add",
  "use": "icon-referral-add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-referral-add\">\n    <path d=\"M13.5 11h6.933a1 1 0 1 1 0 2H13.5v7a1 1 0 0 1-2 0v-7H4.567a1 1 0 1 1 0-2H11.5V4a1 1 0 1 1 2 0v7z\" fill-rule=\"nonzero\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol